<template>
    <vuestic-widget header-text="Requerimientos">
        <router-link :to="{name: 'crearRequermiento'}">
            <button class="btn btn-micro btn-warning">Agregar Requerimiento</button>
        </router-link>
        <hr />
        <table class="table table-striped table-bordered">
        <thead class="thead-light">
            <tr>
                <th>Título</th>
                <th>Usuario</th>
                <th>Fecha</th>
                <th>Ú.Estado</th>
                <th>Fecha Ú.Modificación</th>
                <th>Opciones</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="req in requerimientos">
                <td>{{req.titulo}}</td>
                <td>{{req.solicitante.nombre}}</td>
                <td>{{req.fecha | fecha}}</td>
                <td>{{Array.from(req.modificaciones).pop().estado.toUpperCase()}}</td>
                <td>{{Array.from(req.modificaciones).pop().fecha | fecha}}</td>
                <td>
                    <i class="fa fa-eye" @click="toDetails(req)"></i>
                </td>
            </tr>
            </tbody>
        </table>
    </vuestic-widget>
</template>

<script>
    import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
    import {URL_REQUERIMIENTO} from "../routes";
    import moment from 'moment'
    export default {
        name: 'solicitud',
        components: {VuesticWidget},
        created() {
            this.$axios.get(URL_REQUERIMIENTO).then(({ data }) => {
                this.requerimientos = data.items
            })
        },
        methods: {
            toDetails(req) {
                this.$router.push({name: 'detalleRequerimiento', query: { id: req.id }, params: req})
            }
        },
        data(){
            return {
                requerimientos: []
            }
        },
        filters: {
            fecha: function(value) {
                return moment(value).format('DD/MM/YY HH:mm')
            }
        }
    }
</script>
